import { internal, template } from '../../vendor/elix.js';

function WithSlotMixin(Base, slotName, slotPosition='append') {

  return class WithSlot extends Base {

    [internal.render](changed) {
      super[internal.render](changed);
      this.renderSlotContainerClassName();
    }

    getContainerToAnnotateWithClassName() {
      return this;
    }

    getTemplateContainerToAppendSlotsTo(template) {
      return template;
    }

    renderSlotContainerClassName() {
      const hasSlottedContent = this.hasSlottedContent();
      const container = this.getContainerToAnnotateWithClassName();
      const className = `with-${slotName}-slot-contents`;
      if (hasSlottedContent) {
        container.classList.add(className);
      } else {
        container.classList.remove(className);
      }
    }

    hasSlottedContent() {
      const isMicrosoftEdge = typeof HTMLSlotElement === 'undefined';
      if (isMicrosoftEdge) {
        return !!this.querySelector(`[slot=${slotName}]`);
      } else {
        const slot = this.shadowRoot.querySelector(`slot[name=${slotName}]`);
        return !!(slot && slot.assignedElements().length);
      }
    }

    get [internal.template]() {

      const templateResult = template.concat(
        super[internal.template],
        template.html`
          <slot name='${slotName}'></slot>
        `
      );

      const slot = templateResult.content.querySelector(`slot[name=${slotName}]`);
      const container = this.getTemplateContainerToAppendSlotsTo(templateResult.content);
      if (slotPosition === 'prepend') {
        container.prepend(slot);
      } else {
        container.appendChild(slot);
      }

      const templateCopy = document.createElement('template');
      templateCopy.innerHTML = templateResult.innerHTML;
      return templateCopy;
    }

  }

}

export default WithSlotMixin;
